type PreviewPaneImgProps = {
  src: string;
  alt: string;
};

export default function PreviewPaneImg({ src, alt }: PreviewPaneImgProps) {
  return (
    <div>
      <img src={src} alt={alt} />
    </div>
  );
}
